/**
 * Calculate Squareup fee from amount
 * so you can charge Squareup fee to customers
 * 
 * Squareup Fee based on currency
 * const fees = {
    GBP: {Percent: 2.5, Fixed: 0.21},
    USD: {Percent: 2.9, Fixed: 0.3},
    EUR: {Percent: 2.4, Fixed: 0.24},
    CAD: {Percent: 2.9, Fixed: 0.3},
    AUD: {Percent: 2.9, Fixed: 0.3},
    NOK: {Percent: 2.9, Fixed: 2},
    DKK: {Percent: 2.9, Fixed: 1.8},
    SEK: {Percent: 2.9, Fixed: 1.8},
    JPY: {Percent: 3.6, Fixed: 0},
    MXN: {Percent: 3.6, Fixed: 3},
    INR: {Percent: 2.0, Fixed: 0},
  };
 */

interface IFee {
  amount: number;
  fee: string;
  total: string;
}

export const calculateSquareupFee = (nftAmount: number): IFee => {
  const amount = parseFloat(nftAmount.toString());
  // {Percent: 4.0, Fixed: 0.45} - generalized for all currencies
  const fee = amount * (4.0 / 100) + 0.45;
  const total = amount + fee;

  return {
    amount,
    fee: fee.toFixed(2),
    total: total.toFixed(2),
  };
};

